import React, { useEffect, useState } from "react";
import { DirectionsRun, Block } from "@mui/icons-material";

const Motion1Widget = ({ widget, onValueUpdate }) => {
  const [isMotion, setIsMotion] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      setIsMotion(widget.items.$w1.value === "motion");
    }
  }, [widget]);

  const getStatusText = () => {
    return isMotion ? "motion" : "no motion";
  };

  const getMotionIcon = () => {
    return isMotion ? (
      <DirectionsRun style={{ fontSize: "1.2rem" }} />
    ) : (
      <Block style={{ fontSize: "1.2rem" }} />
    );
  };

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-300"
      style={{
        height: "40px",
        borderColor: isMotion ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      {getMotionIcon()}
      <span className="text-[0.925rem] font-medium capitalize whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {getStatusText()}
      </span>
    </div>
  );
};

export default Motion1Widget;
